module.exports = {"411303002":"七一街道","411303003":"卧龙岗街道","411303004":"武侯街道","411303005":"梅溪街道","411303006":"车站街道","411303007":"光武街道","411303008":"靳岗街道","411303101":"石桥镇","411303102":"潦河镇","411303103":"安皋镇","411303104":"蒲山镇","411303105":"陆营镇","411303106":"青华镇","411303107":"英庄镇","411303108":"潦河坡镇","411303300":"七里园乡","411303305":"谢庄乡","411303306":"王村乡","411303400":"龙王沟风景区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411303.json
// module id = 1497
// module chunks = 0